export const plural = (count: number): string => {
  return count === 1 ? '' : 's';
};
